<template>
  <form
    class="flex flex-col gap-4"
    @submit.prevent="handleSubmit"
  >
    <label class="label">
      Gift Option
      <select
        v-model="selectedVariant"
        class="input input-select"
      >
        <option
          v-for="variant in product.variants"
          :key="variant.id"
          :value="variant"
        >
          {{ variant.title }}
        </option>
      </select>
    </label>

    <label>
      First Name:
      <input
        v-model="properties.__rc_gift_recipient_first_name"
        class="input text-input"
      >
    </label>
    <label>
      Last Name:
      <input
        v-model="properties.__rc_gift_recipient_last_name"
        class="input text-input"
      >
    </label>
    <label>
      Email:
      <input
        v-model="properties.__rc_gift_recipient_email"
        class="input text-input"
      >
    </label>
    <label>
      Note:
      <textarea
        v-model="properties.__rc_gift_recipient_note"
        class="input textarea"
      />
    </label>

    <!-- <pre>{{ JSON.stringify(properties, null, 2) }}</pre> -->

    <button
      class="button +green +large"
      @click="$cart.add(product, selectedVariant, properties)"
    >
      Add to Cart
    </button>
  </form>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useProductsStore } from '@/stores'
const store = useProductsStore()
const { product } = storeToRefs(store)
const selectedVariant = ref(product.value?.variants?.[0])
const properties = ref({
  '__rc_gift_recipient_first_name': '',
  '__rc_gift_recipient_last_name': '',
  '__rc_gift_recipient_email': '',
  '__rc_gift_recipient_note': ''
})
</script>
